<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{ search }}<br /><br />
    {{ item }} -->
        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable text-left">
                <b-card-body class="py-0">
                    <b-tabs class="gridtabs">
                        <b-tab :active="true">
                            <template #title>
                                <div class="badgecontainer pr-5">
                                    <i :class="options.icon" class="text-primary mr-1"></i>
                                    <span class="text-center badgenormal badge-secondary badge-pill">
                                        {{ item.code }}
                                    </span>
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                                        }}&gt;</span>
                                </div>
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'BL A/C')
                                            " :class="$helpers
                                                .requiredlabel(requirement, 'BL A/C')
                                                .slice(0, 1) == '*'
                                                ? 'text-danger'
                                                : ''
                                                " label-size="sm">
                                            <!-- <b-form-group label="BL A/C" label-for="code" label-cols="12"> -->
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.code" placeholder="Enter BL A/C"
                                                    size="sm" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.code = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Trading Name')
                                            " :class="$helpers
                                                .requiredlabel(requirement, 'Trading Name')
                                                .slice(0, 1) == '*'
                                                ? 'text-danger'
                                                : ''
                                                " label-size="sm">
                                            <!-- <b-form-group label="Trading Name" label-for="description" label-cols="12"> -->
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.description"
                                                    placeholder="Enter client short name" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.description = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Legal Entity Name" label-for="name" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.name"
                                                    placeholder="Enter client name" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.name = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Supplier Type')
                                            " :class="$helpers
                                                .requiredlabel(requirement, 'Supplier Type')
                                                .slice(0, 1) == '*'
                                                ? 'text-danger'
                                                : ''
                                                " label-size="sm">
                                            <b-input-group class="treeselect_all" style="left:80px; top:-12px">
                                                <i class="fa fa-info-circle text-black" id="suptype"></i>
                                            </b-input-group>
                                            <b-tooltip target="suptype" triggers="hover" placement="top">Please
                                                refer to the 'Supplier
                                                Types' table
                                                to determine a default coding for the Nominal ledger.</b-tooltip>
                                            <!-- <b-form-group label="Supplier Type" label-for="suptype" label-cols="12"> -->
                                            <treeselect instanceId="suptype" type="number" v-model="item.suptype"
                                                :clearable="true" :options="suppliertype_options"></treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label="Addressee" label-for="address_addressee" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.address_addressee"
                                                    placeholder="Enter addressee" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.address_addressee = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Account Currency" label-for="type" label-cols="12">
                                            <treeselect instanceId="currency" type="number" v-model="item.currency"
                                                :clearable="true" :options="currency_options"></treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Budget Currency" label-for="type" label-cols="12">
                                            <treeselect instanceId="currency" type="number"
                                                v-model="item.budgetcurrency" :clearable="true"
                                                :options="currency_options"></treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <!-- <b-col cols="12" sm="6">
                                        <b-form-group label="Address FAO" label-for="address_fao" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.address_fao"
                                                    placeholder="Enter address FAO" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.address_fao = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col> -->
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Attributes" label-for="attributes" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.attributes"
                                                    placeholder="Attributes" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.attributes = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label="Address Line 1" label-for="address_line1" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.address_line1"
                                                    placeholder="Enter address line 1" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.address_line1 = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Vatable" label-for="vatable" label-cols="12">
                                            <b-form-radio-group id="vatable" v-model="item.vatable" :options="[
                                                { text: 'Yes', value: '1' },
                                                { text: 'No', value: '0' },
                                            ]" buttons button-variant="outline-success" size="sm"
                                                name="radio-btn-outline"></b-form-radio-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-row>
                                            <b-col>
                                                <b-form-group label="OnStop?" label-for="onstop" label-cols="12">
                                                    <b-form-radio-group id="onstop" v-model="item.onstop" :options="[
                                                        { text: 'Yes', value: '1' },
                                                        { text: 'No', value: '0' },
                                                    ]" buttons button-variant="outline-success" size="sm"
                                                        name="radio-btn-outline"></b-form-radio-group>
                                                </b-form-group></b-col>
                                            <b-col>
                                                <b-form-group label="Active?" label-for="active" label-cols="12">
                                                    <b-form-radio-group id="active" v-model="item.active" :options="[
                                                        { text: 'Yes', value: '1' },
                                                        { text: 'No', value: '0' },
                                                    ]" buttons button-variant="outline-success" size="sm"
                                                        name="radio-btn-outline"></b-form-radio-group>
                                                </b-form-group></b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label="Address Line 2 (optional)" label-for="address_line2"
                                            label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.address_line2"
                                                    placeholder="Enter address line 2" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.address_line2 = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Tel" label-for="phone" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.phone"
                                                    placeholder="Enter phone no" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.phone = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Fax" label-for="fax" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.fax" placeholder="Enter fax"
                                                    size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.fax = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label="City/Town" label-for="address_city" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.address_city"
                                                    placeholder="Enter city/town" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.address_city = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Email" label-for="email" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.email" placeholder="Enter email"
                                                    size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.email = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label="County (optional)" label-for="address_county"
                                            label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.address_county"
                                                    placeholder="Enter county" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.address_county = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label="Postcode" label-for="address_postcode" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.address_postcode"
                                                    placeholder="Enter postcode" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.address_postcode = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Country" label-for="address_country" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.address_country"
                                                    placeholder="Enter country" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.address_country = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Country ISO" label-for="address_countryiso"
                                            label-cols="12">
                                            <treeselect instanceId="address_countryiso" type="number"
                                                v-model="item.address_countryiso" :clearable="true"
                                                :options="country_options">
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <!--   <b-col cols="12" sm="3">
              <b-form-group
                label="Postcode"
                label-for="postcode"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.postcode"
                    placeholder="Enter postcode"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.postcode = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col> -->
                                </b-row>

                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label="Comments" label-for="comments" label-cols="12">
                                            <b-form-textarea id="data" v-model="item.comments" placeholder="Comments"
                                                rows="6" max-rows="8" class="smalltextarea"></b-form-textarea>
                                        </b-form-group> </b-col></b-row>
                                <b-row>

                                    <!-- <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="N/L Code" label-for="nlcode" label-cols="12">
                <treeselect
                  instanceId="nlcode"
                  type="number"
                  v-model="item.nlcode"
                  :clearable="true"
                  :options="nlcode_options"
                ></treeselect>
              </b-form-group>
            </b-col> -->

                                </b-row>
                            </p>
                        </b-tab>
                        <b-tab v-if="idselected">
                            <template #title>
                                <i class="fa fa-history text-primary mr-1"></i> Audit
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.created_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.updated_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>
                        </b-tab></b-tabs>
                </b-card-body>


                <b-card-footer class="nopadding mt-2">
                    <b-row no-gutters>
                        <b-col cols="auto" class="text-left">
                            <b-button squared size="sm" variant="primary" @click="saveit()"
                                v-if="user.permissions.includes('setup_suppliers.admin')" :disabled="postit_disabled">
                                <i class="fa fa-check"></i>
                                Save It
                            </b-button>
                        </b-col>
                        <b-col class="text-left ml-2 mt-1">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col>
                        <b-col class="text-right" cols="8">
                            <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                                <i class="fa fa-chevron-left pr-1"></i>
                                Back
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-footer>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
    name: "SupplierEdit",
    watch: {
        "item.onstop": {
            immediate: true,
            handler(newVal, oldVal) {
                let newdata = this.item.attributes;
                if (!newdata) {
                    newdata = "";
                }
                if (newVal) {
                    if (!newdata.includes("/S ")) {
                        newdata = "/S " + newdata;
                    }
                } else {
                    newdata = newdata.replace("/S ", "");
                }
                this.item.attributes = newdata;
            },
        },
    },
    data() {
        return {
            busy: false,
            requirement: {
                suptype: "Supplier Type",
                code: "BL A/C",
                description: "Trading Name"
            },
            item: {
                name: null,
                description: null,
                // district: null,
                code: null,
                suptype: null,
                // eventcode: null,
                address_addressee: null,
                address_line1: null,
                address_line2: null,
                address_city: null,
                address_county: null,
                address_postcode: null,
                address_countryiso: null,
                address_country: null,
                phone: null,
                fax: null,
                email: null,
                comments: null,
                // balance: null,
                vatable: '0',
                currency: null,
                budgetcurrency: null,
                region: null,
                summary: null,
                web: null,
                bankdetails: null,
                terms: null,
                onstop: '0',
                active: '1',
                attributes: null,
                created_at: this.$moment().format("YYYY-MM-DD"),
                created_by: null,
            },
            country_options: [],
            // nlcode_options: [],
            suppliertype_options: [],
            currency_options: [],
            options: {
                title: "Supplier",
                icon: "fa fa-industry",
            },
        };
    },
    methods: {
        async loadDDL() {
            console.log("loadDDL");
            this.busy = true;

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query setup_countries {
              setup_countries {
                id: code
                label
              }
            }
          `,
                });
                this.country_options = response.data.setup_countries;
                console.log(this.country_options);
            } catch (error) {
                console.log(error);
            }

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query salesgroups {
              salesgroups {
                id
                label: id
              }
            }
          `,
                });
                this.salesgroups_options = response.data.salesgroups;
            } catch (error) {
                console.log(error);
            }

            // try {
            //   const response = await this.$apollo.query({
            //     query: gql`
            //       query nlcodes {
            //         nlcodes {
            //           id
            //           label
            //         }
            //       }
            //     `,
            //   });
            //   this.nlcode_options = response.data.nlcodes;
            // } catch (error) {
            // }

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query suppliertypes {
              suppliertypes {
                id
                label
              }
            }
          `,
                });
                this.suppliertype_options = response.data.suppliertypes;
            } catch (error) {
                console.log(error);
            }

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query setup_currencies {
              setup_currencies {
                id:code
                label
              }
            }
          `,
                });
                this.currency_options = response.data.setup_currencies;
            } catch (error) {
                console.log(error);
            }

            this.busy = false;
        },
        async load() {
            let variables = {
                id: this.idselected,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
            query setup_suppliers($id: String) {
              setup_suppliers(id: $id) {
                id
                name
                description
                # district
                code
                suptype
                # nlcode
                # eventcode
                address_addressee             
                address_line1
                address_line2
                address_city
                address_county
                address_postcode
                address_countryiso
                address_country
                phone
                fax
                email
                comments
                # balance
                vatable
                currency
                budgetcurrency
                region
                summary
                web
                bankdetails
                terms
                onstop
                active
                attributes
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
                    variables,
                });

                if (response.data.setup_suppliers.length > 0) {
                    this.item = response.data.setup_suppliers[0];
                }
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },
        async saveit() {

            let row = this.cleanit(this.item);

            this.message = this.$helpers.mandatoryFields(
                {
                    suptype: "Supplier Type",
                    code: "BL A/C",
                    description: "Trading Name"
                },
                row
            );

            if (this.message.length > 0) {
                return;
            }


            this.busy = true;

            let variables = { rows: [row] };
            if (this.config.action == 'copy') {
                variables.rows[0].id = null
            }
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
            mutation setup_suppliers_save(
              $rows: [setup_suppliers_input]
            ) {
              setup_suppliers_save(rows: $rows) {
                id
                name
                description
                # district
                code
                suptype
                # nlcode
                # eventcode
                address_addressee            
                address_line1
                address_line2
                address_city
                address_county
                address_postcode
                address_countryiso
                address_country
                phone
                fax
                email
                comments
               # balance
                vatable
                currency
                budgetcurrency
                region
                summary
                web
                bankdetails
                terms
                onstop
                active
                attributes
              }
            }
          `,
                    variables,
                });
                if (response.data.setup_suppliers_save.length > 0) {
                    this.item = response.data.setup_suppliers_save[0];
                }
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
    },
};
</script>

<style></style>